import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AdminAddWebPagesComponent } from "../admin-add-web-pages/admin-add-web-pages.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
@Component({
  selector: "app-admin-web-pages",
  templateUrl: "./admin-web-pages.component.html",
  styleUrls: ["./admin-web-pages.component.css"],
})
export class AdminWebPagesComponent implements OnInit {
  matDialogref!: MatDialogRef<AdminAddWebPagesComponent>;
  modules = {};
  content = "";
  SelectedWebType: string = "termsAndConditions";
  config: any;
  webpageForm!: FormGroup;
  loading: boolean = false;
  token: any;

  constructor(
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getEditorToolBar();
    this.webpageForm = this.formBuilder.group({
      webpage_string: ["", [Validators.required]],
    });
    this.getWebpages();
    let triptype = "web";
    localStorage.setItem("tripType", triptype);
  }

  public AssignWebPageType(SelectedWebType: any) {
    this.SelectedWebType = SelectedWebType;
    this.getWebpages();
  }

  public addWebPage() {
    this.matDialogref = this.matDialog.open(AdminAddWebPagesComponent, {});
  }

  saveWeb() {
    if (this.webpageForm.valid) {
      const webPagesObj = {
        webpage_type: this.SelectedWebType,
        webpage_string: this.webpageForm.value.webpage_string,
      };
      this.services.addWeb(webPagesObj, this.token).subscribe(
        (response: any) => {
          if (response.status == 200 || response.status == 201) {
            this.snackBar.open("Webpage updated successfully", "Success", {
              duration: 5000,
            });
            this.getWebpages();
          }
        },
        (error) => {
          if (error.status == 403) {
            this.router.navigateByUrl("admin/login");
            localStorage.clear();
          }
          if (error.status == 401) {
            this.router.navigateByUrl("admin/login");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed || jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  getWebpages() {
    this.services
      .webPagesGet(this.SelectedWebType)
      .subscribe((response: any) => {
        if (response.body?.data?.webpage_string) {
          this.webpageForm.patchValue({
            webpage_string: response.body.data.webpage_string,
          });
        } else {
          this.webpageForm.patchValue({ webpage_string: "" });
        }
      });
  }

  getEditorToolBar() {
    this.config = {
      editable: true,
      spellcheck: true,
      height: "auto",
      minHeight: "0",
      maxHeight: "auto",
      width: "auto",
      minWidth: "0",
      translate: "yes",
      enableToolbar: true,
      showToolbar: true,
      placeholder: "Enter text here...",
      defaultParagraphSeparator: "",
      defaultFontName: "",
      defaultFontSize: "",
      fonts: [
        { class: "arial", name: "Arial" },
        { class: "times-new-roman", name: "Times New Roman" },
        { class: "calibri", name: "Calibri" },
        { class: "comic-sans-ms", name: "Comic Sans MS" },
      ],
      customClasses: [
        {
          name: "quote",
          class: "quote",
        },
        {
          name: "redText",
          class: "redText",
        },
        {
          name: "titleText",
          class: "titleText",
          tag: "h1",
        },
      ],
      uploadWithCredentials: false,
      sanitize: false,
      toolbarPosition: "top",
    };
  }
}
